import { CascadingTable } from './cascading-table.model';
import { ChildDropDownItemsTable } from './child-dropdown-items-table.model';
import { ChildMdmDropDownItemsTable } from './child-mdm-dropdown-child-table.model';
import { DropDownItemsTable } from './dropdown-items-table.model';
import { FieldsTable } from "./fields-table.model";
import { MdmDropDownItemsTable } from './mdm-dropdown-items-table.model';
import { MdmSearchDropDownItemsTable } from './mdm-search-dropdown-items-table.model';
import { TaxonomiesTable } from './taxonomies-table.model';
import { TaxonomyValuesTable } from './taxonomy-values-table.model';


export class Cache {
    constructor(
        public taxonomies: TaxonomiesTable,
        public fields: FieldsTable,
        public dropDownItems: DropDownItemsTable,
        public childDropDownItems: ChildDropDownItemsTable,
        public mdmDropDownItems: MdmDropDownItemsTable,
        public childMdmDropDownItems: ChildMdmDropDownItemsTable,
        public mdmSearchDropDownItems: MdmSearchDropDownItemsTable,
        public taxonomyValues: TaxonomyValuesTable,
        public cascading: CascadingTable) { }
}
